<template>
  <div>
    <div :class="{ 'aboutStyle': langVar === 'ar', 'aboutStyle aboutStyleEn': langVar === 'en', }">
      <h1>{{$t('commonQuestionsTitle')}}</h1>
      <h3>{{$t('commonQuestions')}}</h3>
      <h6>
        {{$t('answerIntro')}}
      </h6>
      <a href="/common-question" :class="{ 'btn89': langVar === 'ar', 'btn89 btn89en': langVar === 'en', }">
        <button class="button-89" role="button">{{$t('detailsBtn')}}</button>
    </a>
    </div>
  </div>
</template>

<script>
import store from '../../store';
import { mapState } from "vuex";
export default {
  data(){
    return{
      langVar: store.state.currentLang,
    }
  },
  computed: {
    ...mapState(["currentLang"]),
    currentLang() {
      return store.state.currentLang;
    },},
    
}

</script>

<style scoped>
.aboutStyle {
  margin-top: 70px;
  padding-top: 140px;
  padding-bottom: 50px;
  background-image: url("../../assets/images/questions.png");
  background-repeat: no-repeat;
  background-position-x: 4%;
  background-position-y: 40%;
  background-color: #8d8a87;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.aboutStyle > h1 {
  color: #fdc948;
  font-size: 50px;
  font-weight: bolder;
  margin-right: 8%;
}
.aboutStyle > h3 {
  color: #dbd6c3;
  font-weight: bolder;
  margin-right: 8%;
}
.aboutStyle > h6 {
  color: white;
  margin-right: 12%;
  margin-top: 20px;
  width: 50%;
  line-height: 35px;
  font-size: 18px;
}


.aboutStyleEn{
  background-position-x: 90%;  
  direction: ltr !important;
  padding-top: 60px;
  padding-bottom: 50px;
}
.aboutStyleEn > h1 {
  margin-left: 3%;
}

.aboutStyleEn>h3{
  width: 50%;
  direction: ltr !important;
  margin-left: 3%;
  line-height: 35px;
}
.aboutStyleEn>h6{
  direction: ltr !important;
  margin-left: 7%;
}
.btn89{
  margin-right: 31%;
}

.btn89en{
  margin-left: 31%;

}
.button-89 {
  --b: 3px; 
  --s: .45em;
  --color: #dbd6c3;
  font-weight: 800;
  width: 100%;
  margin-top: 30px;
  
  padding: calc(.5em + var(--s)) calc(.9em + var(--s));
  color: var(--color);
  --_p: var(--s);
  background:
    conic-gradient(from 90deg at var(--b) var(--b),#0000 90deg,var(--color) 0)
    var(--_p) var(--_p)/calc(100% - var(--b) - 2*var(--_p)) calc(100% - var(--b) - 2*var(--_p));
  transition: .3s linear, color 0s, background-color 0s;
  outline: var(--b) solid #0000;
  outline-offset: .6em;
  font-size: 16px;

  border: 0;

  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
}

.button-89:hover,
.button-89:focus-visible{
  --_p: 0px;
  outline-color: var(--color);
  outline-offset: .05em;
}

.button-89:active {
  background: var(--color);
  color: #fff;
}

@media (max-width:1200px) {
  .aboutStyle>h6, .aboutStyle>h1, .aboutStyle>h3{
    width: 50%;
  }
  .aboutStyle{
    background-size: 40%;

  }
}

@media (max-width:800px) {
  .aboutStyle>h6, .aboutStyle>h1, .aboutStyle>h3{
    width: 80%;
  }
  .aboutStyle{
    background-image: url("");

  }
}
</style>
